<template>
    <div id="CreateFaqs">
        <div class="header">
            <div class="title">
                <IconButton :on-click="() => $emit('close')">
                    <i class="material-icons">arrow_back_ios</i>
                </IconButton>
                Create Frequently Asked Questions (FAQ)
            </div>
            <div class="description">
                Create a new FAQ for your chatbot. This will help your chatbot to answer the user's questions.
            </div>
        </div>
        <div class="content">
            <div>Question</div>
            <input
                v-model="question"
                type="text" />
            <div>Answer</div>
            <textarea
                v-model="answer"
            ></textarea>
            <div class="btn-container">
                <SupsisButton primary class="sup-btn" @click="saveFaq">
                    <i class="material-icons">save</i>
                    <span>Save</span>
                </SupsisButton>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import IconButton from "../../../Settings/components/IconButton.vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";

export default {
    name: "CreateFaqs",
    props: {
        storyId: {
            type: String,
            required: true,
        },
    },
    components: {
        IconButton,
        SupsisButton,
    },
    data() {
        return {
            question: "",
            answer: "",
        };
    },
    computed: {
        ...mapState({}),
    },
    methods: {
        ...mapActions({}),
        async saveFaq() {
            this.$emit("save-faq", {
                question: this.question,
                answer: this.answer,
            });
        },
    },
};
</script>
<style lang="scss" scoped>
#CreateFaqs {
    margin: 30px;

    .header {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .title {
            display: flex;
            gap: 10px;
            color: #22272d;
            font-size: 28px;
            font-weight: 700;
        }

        .description {
            color: #22272d;
            font-size: 18px;
            line-height: 23px;
            margin-top: 8px;
            margin-bottom: 10px;
        }
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 20px;
        background-color: #f5f5f5;
        border-radius: 10px;
    }

    .content div {
        font-size: 18px;
        font-weight: bold;
        color: #333;
    }

    .content input[type="text"], .content textarea {
        padding: 10px;
        border: 1px solid #ccc;
        border-radius: 5px;
        font-size: 16px;
        width: 100%;
    }

    .content textarea {
        height: 400px;
        resize: vertical;
    }

    .sup-btn {
        float: right;
        color: white !important;
    }
}
</style>
